export enum SlideEventType {
  NEXT = 'NEXT',
}

export default interface ISlideEvent {
  slideEventType: SlideEventType;
  slideIndex: number;
  indexTime: number; //ms
}